<template>
  <section class="hero-livreurs container-fluid px-0">
    <div class="row g-0 flex-lg-row flex-column">
      <!-- Col gauche : à qui on s’adresse (fond vert) -->
      <div
        class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center hero-left"
      >
        <div class="content">
          <p class="badge">ESPACE LIVREURS</p>
          <h1 class="title">
            Vous êtes livreur indépendant<br />
            ou transporteur pour le <span class="highlight">BTP&nbsp;?</span>
          </h1>
          <p class="description">
            <strong>Chauffeur indépendant</strong>, petite flotte de véhicules
            utilitaires,
            <strong>transporteur spécialisé chantier</strong>&nbsp;: si vous
            <strong>livrez des professionnels</strong> ou souhaitez développer
            cette activité, Livratos vous ouvre un accès direct aux dépôts
            matériaux et aux <strong>chantiers</strong>.
          </p>
          <p class="description">
            La plateforme devient votre source de
            <strong>missions dédiée au BTP</strong>&nbsp;: vous choisissez les
            courses qui vous intéressent en fonction du véhicule, de la zone et
            des horaires, en gardant la main sur votre organisation.
          </p>
        </div>
      </div>

      <!-- Col droite : pourquoi utiliser Livratos (fond noir) -->
      <div
        class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center hero-right"
      >
        <div class="content">
          <h2 class="subtitle">
            Pourquoi livrer avec <span class="accent">Livratos</span>&nbsp;?
          </h2>
          <p class="description">
            Livratos centralise des demandes de
            <strong>livraisons BTP</strong> qualifiées&nbsp;: enlèvement en
            dépôt, <strong>livraison chantier</strong>, contraintes d’accès et
            type de chargement clairement indiqués avant d’accepter la mission.
          </p>

          <ul class="hero-benefits">
            <li>
              <strong>Des courses qualifiées</strong>&nbsp;: type de véhicule,
              volume estimé, adresses et contacts déjà renseignés.
            </li>
            <li>
              <strong>Moins de temps perdu</strong>&nbsp;: moins
              d’allers-retours à vide, des trajets pensés pour le terrain BTP.
            </li>
            <li>
              <strong>Pas de prospection</strong>&nbsp;: les demandes viennent
              des <strong>fournisseurs et artisans</strong> déjà présents sur
              Livratos.
            </li>
            <li>
              <strong>Suivi et historique</strong>&nbsp;: courses, montants et
              périodes regroupés pour une activité plus lisible.
            </li>
          </ul>

          <div class="d-flex gap-3 mt-4 flex-wrap">
            <a href="https://www.livratos.app" class="btn btn-cta fw-semibold">
              Créer mon compte livreur
            </a>
            <a
              href="/contact"
              class="btn btn-link text-decoration-none fw-medium link-more"
            >
              Parler à l’équipe Livratos
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.hero-livreurs {
  margin-top: 72px;
  margin-bottom: 72px;

  .content {
    max-width: 540px;
    margin: auto;
  }

  /* === Mobile / par défaut : blocs empilés vert puis noir === */
  .hero-left {
    background-color: $color-primary;
    color: #ffffff;

    .badge {
      display: inline-block;
      background-color: rgba(#000000, 0.16);
      color: #000;
      font-size: 0.7rem;
      font-weight: 600;
      padding: 0.3rem 0.9rem;
      border-radius: 50px;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .title {
      font-size: 2.2rem;
      font-weight: 700;
      color: #ffffff;
      margin-top: 1rem;
      line-height: 1.3;

      .highlight {
        color: #000000;
      }

      @media (min-width: 768px) {
        font-size: 3rem;
      }
    }

    .description {
      color: rgba(#ffffff, 0.92);
      margin-top: 1.1rem;
      font-size: 1rem;
      line-height: 1.7;

      @media (min-width: 768px) {
        font-size: 1.05rem;
      }
    }
  }

  .hero-right {
    background-color: #000000;
    color: #ffffff;

    .subtitle {
      font-size: 1.7rem;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 0.75rem;

      .accent {
        color: $color-primary;
      }

      @media (min-width: 768px) {
        font-size: 2rem;
      }
    }

    .description {
      color: rgba(#ffffff, 0.9);
      margin-top: 0.8rem;
      font-size: 1rem;
      line-height: 1.7;

      @media (min-width: 768px) {
        font-size: 1.05rem;
      }
    }

    .hero-benefits {
      margin-top: 1rem;
      padding-left: 0;
      list-style: none;

      li {
        position: relative;
        padding-left: 1.3rem;
        margin-bottom: 0.45rem;
        font-size: 0.95rem;
        color: rgba(#ffffff, 0.9);

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.55em;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: $color-primary;
          box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          transform: translateY(-50%);
        }
      }
    }

    .btn-cta {
      background-color: $color-primary;
      border: 1px solid $color-primary;
      color: #000;
      padding: 0.65rem 1.6rem;
      border-radius: 6px;
      font-size: 0.95rem;
      text-transform: uppercase;

      &:hover {
        background-color: darken($color-primary, 8%);
        border-color: darken($color-primary, 8%);
        color: #000;
      }
    }

    .link-more {
      color: #ffffff;
      font-size: 0.95rem;

      &:hover {
        color: $color-primary;
        text-decoration: underline;
      }
    }
  }

  /* === Desktop : diagonale noir/vert comme pour fournisseurs === */
  @media (min-width: 992px) {
    position: relative;
    overflow: hidden;
    background-color: $color-primary;

    .hero-left {
      background-color: transparent;
    }

    .hero-right {
      background-color: transparent;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: -10%;
      bottom: 0;
      width: 60%;
      background-color: #000000;
      transform: skewX(-10deg);
      transform-origin: top right;
      z-index: 0;
    }

    .hero-left,
    .hero-right {
      position: relative;
      z-index: 1;
    }
  }
}
</style>
